import React, { useState, useEffect } from "react";
import axios from "axios";
import { Grid, Divider, Typography } from "@mui/material";
import { DataGrid, GridOverlay } from '@mui/x-data-grid';
import TableToolbar from "../UI/TableToolbar/TableToolbar";
import { styled } from "@mui/material/styles";
import { CDCard, CDCardContent, CDCardHeader } from "../../const/CDCardStyles";
import CheckValidSortModel from '../../functions/CheckValidSortModel';
import { UsersHeader } from "../../const/DatatableData";
import { getUsersPaginated, exportUsers, getUserRoles, getDispositivi } from "../../const/CardDati";
import AdvancedFilterPanel from "./AdvancedFilterPanel";
import { useSelector, useDispatch } from "react-redux";
import { openEmptyDialogUser } from "../../redux/reducers/dialogUser-reducer";
import UserDialog from "../UI/Dialog/UserDialog";
import handlerError from "../../functions/handlerError";
import {notificationOpen}  from "../../redux/reducers/notification-reducer";
import { loadUserRolesState } from "../../redux/reducers/userRolesSlice-reducer";
import { loadDevicesState } from "../../redux/reducers/devices-reducer";
import Notification from "../UI/Notification/Notification";
import { formatDate } from "../../functions/formatDate";


const StyledDataGrid = styled(DataGrid)(() => ({
    '& .MuiDataGrid-columnHeader:focus': {
      outline: 'none'
    }, 
    '& .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none'
    },
    '& .MuiDataGrid-root': {
        outline: 'none !important'
    },
    '& .MuiDataGrid-cell:focus-within':{
        outline: 'none !important'
    }
}));

const typePage = "Utenti";
const urlBase = process.env.REACT_APP_URL;
const columns = UsersHeader.headers;


const UsersDatatable = () => {

    const dispatch = useDispatch();
    const reloading = useSelector((state => state.dataTableUsers))
    const [searchFilter, setSearchFilter] = useState('');
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [rows, setRows] = useState([]);
    const [rowsCount, setRowsCount] = useState(rows.length);
    const [loading, setLoading] = useState(false);
    const [sortModel, setSortModel] = useState([{
        field: UsersHeader.initialFieldName,
        sort: UsersHeader.initialFieldOrder
    }]);
    const [filterParameters, setFilterParameters] = useState({
        radioUserEnabled: null
    });


    const handleFilterData = (radioUserEnabled) => {
        let newFilterParameters = {
            radioUserEnabled: JSON.parse(radioUserEnabled)
        };

        setFilterParameters(newFilterParameters);
    };

    const handleSearchFilter = (searchText) => {
      setSearchFilter(searchText);
    };

    const handleDownloadXLS = () => {

      const { sortField, sortOrder } = CheckValidSortModel(sortModel, UsersHeader.initialFieldName);
      const { action, method } = exportUsers;
      const { radioUserEnabled } = filterParameters;
      let url = urlBase + action;
      
      const requestBody = {
        pageIndex: page,
        pageSize: pageSize,
        sortColumnName: sortField,
        sortDirection: sortOrder,
        applyPaginationAndSort: false,
        radioUserEnabled: radioUserEnabled,
        searchFilter: searchFilter
      };
  
      (async() => {
        try{
          const response = await axios({
            method: method,
            url,
            data: requestBody,
            responseType: 'blob'
          });
          
          const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          const blob = new Blob([response.data], { type: contentType });
          const urlDownload = window.URL.createObjectURL(blob);

          let a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = urlDownload;
          a.download = "Export-Utenti-" + formatDate(new Date());
          a.click();
          window.URL.revokeObjectURL(url);

        } catch(error){
          console.error(error);
          const notificationError = handlerError(error)
          dispatch(notificationOpen(notificationError))
        } 
      })();
    }; 
    
    useEffect(() => {
      const { sortField, sortOrder } = CheckValidSortModel(sortModel, UsersHeader.initialFieldName);
        
        (async() => {
            setLoading(true);

            const { radioUserEnabled } = filterParameters;
            const { action, method } = getUsersPaginated;
            let url = urlBase + action;

            const requestBody = {
                pageIndex: page,
                pageSize: pageSize,
                sortColumnName: sortField,
                sortDirection: sortOrder,
                applyPaginationAndSort: true,
                searchFilter: searchFilter,
                radioUserEnabled: radioUserEnabled
            };


            try{
                const response = await axios({
                    method: method,
                    url,
                    data: requestBody
                });
                
                const newRows = response.data.result.result;
                const newRowsCount = response.data.result.result.totalFiltered;
                setRows(newRows);
                setRowsCount(newRowsCount);

                if(!response.data.ok){
                  dispatch(notificationOpen({message:response.data.message,status:response.data.ok }));
                }   

            } catch(error){
                console.error(error);
                const notificationError = handlerError(error);
                dispatch(notificationOpen(notificationError));
            } 
            
            setLoading(false);

        })();
    }, [page, pageSize, sortModel, searchFilter, reloading, filterParameters]);

    useEffect(() => {
      (async() => {
        const { action, method } = getUserRoles;
        let url = urlBase + action;
        const requestBody = {}
        try{
          const response = await axios({
            method: method,
            url,
            data: requestBody
          });

          if(response.data.ok){
            dispatch(loadUserRolesState(response.data.result));
          }     
        } catch(error){
          console.error(error);
          const notificationError = handlerError(error);
          dispatch(notificationOpen(notificationError));
        } 
      })();

      (async() => {
        const { action, method } = getDispositivi;
        let url = urlBase + action;

        try{
          const response = await axios({
            method: method,
            url
          });

          if(response.data.ok){
            dispatch(loadDevicesState(response.data.result));
          }     
        } catch(error){
          console.error(error);
          const notificationError = handlerError(error);
          dispatch(notificationOpen(notificationError));
        } 
      })();
    }, []);

    
    return (
      <>
        <Grid container item>
          <Grid item component={CDCard} xs={12} sm={12}>
            <CDCardHeader title="Elenco Utenti" />
            <Divider />
            <CDCardContent>
              <AdvancedFilterPanel handleFilterData={handleFilterData} />
              <Divider sx={{ mb: 2 }} />
              <Grid container item>
                <StyledDataGrid
                  rows={rows}
                  rowCount={rowsCount}
                  getRowId={(row) => row.id}
                  columns={columns}
                  page={page}
                  pageSize={pageSize}
                  onPageChange={(newPage) => setPage(newPage)}
                  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                  onSortModelChange={(newSortModel) =>
                    setSortModel(newSortModel)
                  }
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  disableSelectionOnClick
                  sortModel={sortModel}
                  sortingMode="server"
                  sortingOrder={["asc", "desc"]}
                  paginationMode="server"
                  loading={loading}
                  sx={{ border: 0 }}
                  disableColumnMenu
                  disableColumnFilter
                  disableColumnSelector
                  autoHeight
                  autoWidth
                  components={{
                    Toolbar: () => (
                      <TableToolbar
                        typePage={typePage} 
                        enableAdd={true}
                        enableSearch={true}
                        enableExport={true}
                        handleAdd={() => {dispatch(openEmptyDialogUser("add"));}}
                        downloadXLS={handleDownloadXLS}
                        initialSearchText={searchFilter}
                        startSearch={handleSearchFilter}
                      />
                    ),
                    NoRowsOverlay: () => (
                      <GridOverlay>
                        <Typography>Nessuna riga</Typography>
                      </GridOverlay>
                    ),
                    NoResultsOverlay: () => (
                      <GridOverlay>
                        <Typography>Nessuna riga</Typography>
                      </GridOverlay>
                    )
                  }}
                />
              </Grid>
            </CDCardContent>
          </Grid>
        </Grid>
        <Notification />
        <UserDialog />
      </>
    );
};

export default UsersDatatable;